/*
 * Developed by HuMingZhi on 7/28/19 5:56 PM
 * Copyright (c) 2019. All right reserved.
 */
import { isProductionMode } from '../utils/mode';
/* eslint-disable no-param-reassign */
(function () {
    (function (win, doc, tag, url, name, appId, 
    // TODO: 有待补充
    requiredKey, eScript, eArchor
    // eslint-disable-next-line max-params
    ) {
        win['MarioJSSDKObject'] = name;
        // @ts-ignore
        win[name] =
            win[name] ||
                function () {
                    // eslint-disable-next-line function-paren-newline
                    (win[name].q = win[name].q || []).push(arguments
                    // eslint-disable-next-line function-paren-newline
                    );
                };
        win[name].id = appId;
        win[name].r = requiredKey;
        win[name].l = Number(new Date());
        eScript = doc.createElement(tag);
        eArchor = doc.getElementsByTagName(tag)[0];
        eScript.async = 1;
        eScript.src = url;
        eArchor.parentNode.insertBefore(eScript, eArchor);
    })(window, document, 'script', 'https://tms3.bytecdn.cn/s/assets/js/eventCollector_e6f797e.js', 'collectEvent');
    /*
     ** user参数为必传参数，非登录页面使用需生成一个唯一ID
     */
    function setCookie(c_name, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        try {
            var c_value = escape(value) +
                (exdays == null ? '' : '; expires=' + exdate.toUTCString());
            document.cookie = c_name + '=' + c_value;
        }
        catch (e) { }
    }
    function getCookie(c_name) {
        var i;
        var x;
        var y;
        var ARRcookies = document.cookie.split(';');
        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
            x = x.replace(/^\s+|\s+$/g, '');
            if (x === c_name) {
                return unescape(y);
            }
        }
        return null;
    }
    function guid() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0)
                .toString(16)
                .substring(1);
        }
        return ('TEA-' +
            S4() +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            S4() +
            S4());
    }
    var uid = getCookie('_tea');
    if (uid == null) {
        uid = guid();
        setCookie('_tea', uid, 365);
    }
    /*
     **设置相关参数
     */
    window.collectEvent.ready = function (instance) {
        instance.setDebug(isProductionMode); // 开发测试时一定要使用debug模式，以免影响统计数据
        instance.setIntranetMode(false);
        instance.setRequiredKeys({
            user: ['user_unique_id'],
            header: ['app_id', 'app_name']
        });
        instance.setUser({
            user_unique_id: uid
        });
        instance.setHeader({
            app_id: 1215,
            app_name: 'fangxingou'
        });
    };
})();
